<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card-header-danger">
        <h4 class="card-title">Delivery Information</h4>
        <p class="card-category">
          Your delivery settings per country. New products you add in a country start with these.
        </p>
      </div>
      <div class="card-body">
        <div class="table-scroll">
          <table mat-table [dataSource]="rows()" class="w-100">
            <ng-container matColumnDef="iso2">
              <th mat-header-cell *matHeaderCellDef>ISO2</th>
              <td mat-cell *matCellDef="let row">{{ row.iso2 }}</td>
            </ng-container>

            <ng-container matColumnDef="deliveryText">
              <th mat-header-cell *matHeaderCellDef>Delivery Text</th>
              <td mat-cell *matCellDef="let row">
                <mat-form-field class="w-100">
                  <textarea matInput [formControl]="row.formGroup.get('deliveryText')" rows="3"></textarea>
                  @if (row.formGroup.get('deliveryText')?.errors?.['required']) {
                    <mat-error>Delivery text is required</mat-error>
                  }
                </mat-form-field>
              </td>
            </ng-container>

            <ng-container matColumnDef="standardDeliveryFee">
              <th mat-header-cell *matHeaderCellDef>Standard Delivery Fee</th>
              <td mat-cell *matCellDef="let row">
                @if (deliveryZonesFor(row.iso2).length > 0) {
                  <!-- US / MY: charged by the customer's shipping-address state, per zone. -->
                  @if (feeLocked(row.iso2)) {
                    <p class="fee-locked">Set by FishyHub (FishyHub Delivery)</p>
                  }
                  <div class="zone-fees">
                    @for (z of deliveryZonesFor(row.iso2); track z.zone) {
                      <mat-form-field subscriptSizing="dynamic">
                        <mat-label>{{ z.label }}</mat-label>
                        <input matInput type="number" [formControl]="row.formGroup.get(zoneControlName(z.zone))"
                          [readonly]="feeLocked(row.iso2)" />
                        <mat-hint>{{ z.states }}</mat-hint>
                        @if (row.formGroup.get(zoneControlName(z.zone))?.errors?.['required']) {
                          <mat-error>Required</mat-error>
                        }
                        @if (row.formGroup.get(zoneControlName(z.zone))?.errors?.['min']) {
                          <mat-error>Cannot be negative</mat-error>
                        }
                      </mat-form-field>
                    }
                  </div>
                } @else {
                  <mat-form-field>
                    <input matInput type="number" [formControl]="row.formGroup.get('standardDeliveryFee')"
                      [readonly]="feeLocked(row.iso2)" />
                    @if (feeLocked(row.iso2)) {
                      <mat-hint>Set by FishyHub (FishyHub Delivery)</mat-hint>
                    }
                    @if (row.formGroup.get('standardDeliveryFee')?.errors?.['required']) {
                      <mat-error>Required</mat-error>
                    }
                  </mat-form-field>
                }
              </td>
            </ng-container>

            <!-- Walk-in: free text because collection is the merchant's own
                 arrangement - where the shop is, when it opens, what to bring.
                 Blank is how a merchant says they do not offer it. -->
            <ng-container matColumnDef="walkInText">
              <th mat-header-cell *matHeaderCellDef>Walk in</th>
              <td mat-cell *matCellDef="let row">
                <mat-form-field>
                  <textarea
                    matInput
                    [formControl]="row.formGroup.get('walkInText')"
                    rows="3"
                    placeholder="e.g. Collect at 10 Fishery Rd, Mon-Sat 10am-7pm"
                  ></textarea>
                  <mat-hint>Leave blank if walk-in is not offered.</mat-hint>
                </mat-form-field>
              </td>
            </ng-container>

            <ng-container matColumnDef="minSubtotal">
              <th mat-header-cell *matHeaderCellDef>Minimum Subtotal Value</th>
              <td mat-cell *matCellDef="let row">
                <mat-form-field>
                  <mat-label>Enabled</mat-label>
                  <mat-select [formControl]="row.formGroup.get('minSubtotalEnabled')">
                    <mat-option [value]="false">No</mat-option>
                    <mat-option [value]="true">Yes</mat-option>
                  </mat-select>
                </mat-form-field>
                @if (row.formGroup.get('minSubtotalEnabled')?.value) {
                  <mat-form-field>
                    <mat-label>Min. Subtotal</mat-label>
                    <input matInput type="number" [formControl]="row.formGroup.get('minSubtotalValue')" />
                    @if (row.formGroup.get('minSubtotalValue')?.errors?.['required']) {
                      <mat-error>Required</mat-error>
                    }
                    @if (row.formGroup.get('minSubtotalValue')?.errors?.['min']) {
                      <mat-error>Must be greater than 0</mat-error>
                    }
                  </mat-form-field>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let row">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="save(row.iso2)"
                  [disabled]="row.formGroup.invalid || savingIso2() !== null"
                >
                  {{ savingIso2() === row.iso2 ? 'Saving…' : 'Save' }}
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>

        @if (rows().length === 0) {
          <p class="text-muted mt-3">No markets are active for your store yet. Contact FishyHub to enable one.</p>
        }
        @if (success()) {
          <div class="alert alert-success mt-3">{{ success() }}</div>
        }
        @if (error()) {
          <div class="alert alert-danger mt-3">{{ error() }}</div>
        }
      </div>
    </div>
  </div>
</div>
